import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/corex-logo.svg";
import "./Layout.css";

import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "../Elements/SignInButton/SignInButton";
import { SignOutButton } from "../Elements/SignOutButton/SignOutButton";
import { log } from "console";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  console.log(isAuthenticated);

  const goHome = () => {
    navigate("/");
  };

  return (
    <>
      <nav className="header flex justify-between">
        <Logo className="cursor-pointer" onClick={goHome} />
        <div className="">
          {isAuthenticated ? <SignOutButton /> : <SignInButton />}
        </div>
      </nav>
      <div>{children}</div>
    </>
  );
};

export default Layout;
